import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Slider from 'react-slick';
import SlideContent from './slide-content';
import Utils from 'medscape/utils';
import { get } from 'lodash';
import Helpers from 'infosite/helpers';
import SlideIcons from './slide-icons';
import SliderLinks from './slider-links';
import SlideActionsFactory from './slide-actions-factory';
import Buttons from './buttons';
import CarouselTrackingStore from './carousel-tracking-store';
import Tracking from 'medscape/tracking';

window.infosite = window.infosite || {};
window.infosite.modules = window.infosite.modules || {};
window.infosite.modules.sliders = window.infosite.modules.sliders || {};
export default class Carousel extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      caption: props.config.slides[0].caption,
      label: props.config.slides[0].label,
      slideIndex: 0
    }
    this.currentSlide = 0;
    this.Buttons = new Buttons(props.config.icons);
    this.SlideActions = SlideActionsFactory.get(props.config["config-id"]);
    this.TrackingStore = null;
    const moduleId = Math.floor(Math.random() * (new Date()).getTime());
    this.autoPlayResetEvents = `scroll.carousel-${moduleId} resize.carousel-${moduleId} orientationchange.carousel-${moduleId}`;
    this.autoPlayTimeout = null;
  }

  componentDidMount(){
    let $this = $(ReactDOM.findDOMNode(this));
    this.TrackingStore = new CarouselTrackingStore(this.props.config);
    Tracking.trackContainerLinks($this[0]);
    if(this.refs.slider){
      window.infosite.modules.sliders[this.props.config["config-id"]]=this.refs.slider;
    }
    /*
      "Fix" Auto Play issue with Mobile scroll and orientation change events
    */
    if(Utils.isMobile() && this.refs.slider && this.refs.slider.props.autoplay){
      let slider = this.refs.slider;
      slider.innerSlider.autoPlay();
      $(window).on(this.autoPlayResetEvents,(e)=>{
        let slider = this.refs.slider;
        //console.log("AutoPlay Reset Event: ",e)
        //console.log("AutoPlay Reset State: ",slider.innerSlider.state);
        if(slider.innerSlider.state.autoPlayTimer!=null){
          clearTimeout(this.autoPlayTimeout);
          this.autoPlayTimeout = setTimeout( ()=>{
              this.refs.slider.innerSlider.autoPlay();
          },slider.innerSlider.state.autoPlayTimer);
        }
      });
    }
  }

  componentWillUnmount(){
    if(this.TrackingStore){
      this.TrackingStore.stopListeningToAll();
    }
    window.infosite.modules.sliders[this.props.config["config-id"]] = null;
    let autoPlayResetEvents = this.autoPlayResetEvents.split(" ");
    autoPlayResetEvents.forEach(( resetEvent ) => {
      $(window).off(resetEvent);
    })

  }

  doPause(){
    if(this.refs.slider){
        let slider = this.refs.slider;
        slider.innerSlider.pause();
    }
  }
  getSlides(){

    // Move first item to the end hack to fix issue with Slick Slider
    // rendering last item first when slidesToShow is greater than 1
    if(this.props.config.settings.slidesToShow>1){
      let firstSlide = this.props.config.slides.shift();
      this.props.config.slides.push(firstSlide);
    }
    let slides = this.props.config.slides.map( (slide,index)=>{
      let props = $.extend({},slide);
      const key = `slide-${index}`;
      props.index = index;
      props.SlideActions = this.SlideActions;
      props.Buttons = this.Buttons;
      props.pause = this.doPause.bind(this);
      return (
        <div key={key}>
          <SlideContent {...props} />
          <SliderLinks content={this.props.config.links.content} SlideActions={this.SlideActions} Buttons={this.Buttons} />
        </div>
      )
    })
    return slides;
  }
  pauseVideos(){
    let $this = $(ReactDOM.findDOMNode(this));
    Helpers.pauseVideos($this[0]);
  }
  slideCount(){
    let slideCount = null;
    if(this.props.config.slideCount){
      slideCount =  <div className="slide-total">
                      {`${this.state.slideIndex+1} of ${this.props.config.slides.length}`}
                    </div>;
    }
    return slideCount;
  }
  render() {
    let Settings = {
      afterChange: (index)=>{
        this.SlideActions.afterChange(index);
        this.currentSlide = index;
        this.setState({ slideIndex: index })
      },
      beforeChange: (e)=>{
        this.pauseVideos();
        this.SlideActions.beforeChange(e);
      },
      prevArrow: (<this.Buttons.PrevArrow />),
      nextArrow: (<this.Buttons.NextArrow />),
      totalSlides: this.props.config.slides.length,
      ref: 'slider'
    }
    if(this.props.config.settings.customPaging && this.props.config.settings.customPaging.length>0){
      Settings.customPaging = (i)=>{
        let _html = Utils.getDangerousHtml(this.props.config.settings.customPaging);
        let props = {
          className: "custom-paging",
          dangerouslySetInnerHTML: _html
        }
        return <button {...props} ></button>
      }
    }
    else{
      delete this.props.config.settings.customPaging;
    }
    const settings = $.extend({},this.props.config.settings,Settings);
    let IconsProps = $.extend({},this.props.config);
    IconsProps.SlideActions = this.SlideActions;
    IconsProps.Buttons = this.Buttons;
    return (
      <div className="carousel-module">
        <SlideIcons {...IconsProps}/>
        <Slider {...settings}>
          { this.getSlides() }
        </Slider>
        <div>{this.slideCount()}</div>
      </div>
    );
  }
}

Carousel.propTypes={
    config: React.PropTypes.object
}
Carousel.defaultProps={}



// WEBPACK FOOTER //
// ./src/app/carousel/app.jsx